// localhost - DESENV
//export const setBaseURL = "http://192.168.1.188:64001/troltech/metodos/";

// SECEGSERVER - DESENV
//export const setBaseURL = "https://www.secegservicos.com.br:65105/troltech/metodos/";

// SECEGSERVER - PRODUÇÃO
export const setBaseURL = "https://www.secegservicos.com.br:65092/troltech/metodos/";

export default setBaseURL;